import { ApplicationState, ApplicationView, OauthProvider } from '@shared/enums';

export interface ReceivedHelpItem {
  category: string;

  count: number;
}

export enum UserCategoryStatus {
  SuccessfullyVerified = 'successfully-verified',

  FailedVerified = 'failed-verified',

  NonVerified = 'non-verified',
}

export type CustomerGroup = {
  name: string;

  status: UserCategoryStatus;
};

export type Customer = {
  id: number;
  name?: string;
  oauth: OauthProvider[];
  description: string;
  interDescription: string | null;
  phoneNumber: null | string;
  address: {
    regionId: number;
    regionName: string;
    localityName: string;
    district: string;
  };
  groups: CustomerGroup[];
  rating: number;
  receivedHelp: ReceivedHelpItem[];
  avatar: string | null;
};

export type Purchase = {
  id: null | string;
  type: null | string;
  redirectUrl: null | string;
  feedback: null | number;
};

export type ApplicationItem = {
  id: number;
  name: string;
  amount: number;
  unit: string | null;
  state: string;
  category: {
    id: number;
    name: string;
  };
  details: Record<string, unknown> | null;
};

export interface ApplicationShop {
  name: string;

  type: string;
}

export interface SimpleApplication {
  id: number;

  state: ApplicationState;

  view: ApplicationView;

  items: ApplicationItem[];

  shops: ApplicationShop[];

  purchase: Purchase | null;

  updatedAt: string;

  inProgressAt: string;

  inProgressTo: string;
}

export interface Application extends SimpleApplication {
  customer: Customer;
  volunteer: Customer | null;
}

export type ApplicationCardProps = Application;
export type ApplicationCardItemProps = ApplicationItem;
